import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
// import { routerMiddleware } from "react-router-redux";
import { loadUser } from 'redux-oidc';
import userManager from 'src/userManager';
import thunk from 'redux-thunk';
import createRootReducer from 'src/shared/services/reducer';

const initialState = {};

function configureStore() {
  const middlewares = [thunk]; // logger,
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = composeWithDevTools(...enhancers);

  const store = createStore(createRootReducer(), initialState, composedEnhancers);

  loadUser(store, userManager);

  return store;
}

const store = configureStore();

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
